<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <h2>
        {{ this.$t("vehicleAvailableReason.create") }}
      </h2>
    </b-row>

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <b-row class="mt-2">
      <b-col lg="6" md="6" sm="6">
        <vehicle-available-reason
          :model="model"
          :modelstate.sync="modelstate"
        />
      </b-col>
    </b-row>

    <b-row style="margin-top: 40px">
      <b-button @click="save" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    "vehicle-available-reason": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReason.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso",
      },
      model: {
        name: null,
        availabilityReason: null,
      },
    };
  },
  methods: {
    save() {
      this.modelstate = {};
      this.alert.error = "";

      let obj = {
        name: this.model.name,
        availabilityReason: this.model.availabilityReason,
      };
      this.$apiVehicle
        .post("/vehicleAvailableReason/create", obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
            this.clearFields();
          }
          this.clearFields();
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.errorCode === 500) {
            this.alert.error = error.response.data.errorMessage;
            this.$refs.alertDanger.show();
          }
          if (error.response.data.status === 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    clearFields() {
      this.model = {
        name: null,
        availabilityReason: null,
        vehicleModel: null,
      };
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
</style>